import { jsx as _jsx } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import { Colors, transparentize } from '../../Constants/Colors';
import { Size } from '../../Constants/System';
const SizeMap = {
    [Size.small]: 20,
    [Size.medium]: 50,
    [Size.large]: 100,
};
export default function InlineSpinner(props) {
    const size = typeof props.size === 'number' ? props.size : SizeMap[props.size || Size.small];
    const overlay = props.overlay ?? false;
    const margin = props.margin ?? '0';
    return (_jsx(InlineContainer, { "$overlay": overlay, "$margin": margin, className: "spinner-container", children: _jsx(BasicSpinner, { className: props.className, segments: 4, radius: size, thickness: size * 0.4 }) }));
}
const InlineContainer = styled.div `
	${(props) => props.$overlay
    ? css `
					position: absolute;
					top: 0;
					left: 0;
					height: 100%;
					width: 100%;
					background-color: ${transparentize(props.theme.primary, 1 - 0.6)};
					z-index: 700;
				`
    : css `
					margin: ${props.$margin};
				`}
	height: 100%;
`;
const DefaultSpinnerProps = {
    segments: 4,
    radius: 20,
    thickness: 8,
    colors: [Colors.pink, Colors.green, Colors.orange, Colors.blue],
    className: '',
};
export function BasicSpinner(props) {
    const { segments, radius, thickness, colors, className } = { ...DefaultSpinnerProps, ...props };
    const size = radius + thickness;
    let numSegments = segments;
    if (segments <= 0)
        numSegments = 6;
    if (segments > 360)
        numSegments = 360;
    const stepAngle = (2 * Math.PI) / numSegments;
    let lastX = 0;
    let lastY = -radius;
    let lastAngle = 0;
    const arcs = [];
    for (let i = 1; i <= numSegments; i++) {
        const angle = i * stepAngle;
        // Calculate this arc end point
        const x = radius * Math.sin(angle);
        const y = -radius * Math.cos(angle);
        const color = colors ? colors[i % colors.length] : `hsl(${(lastAngle * 180) / Math.PI}, 100%, 50%)`;
        // Create a path element
        arcs.push(_jsx("path", { d: `M${lastX.toFixed(30)} ${lastY.toFixed(30)} A${radius} ${radius} 0 0 1 ${x.toFixed(30)} ${y.toFixed(30)}`, stroke: color, strokeWidth: thickness }, i));
        // Update lastx/y
        lastX = x;
        lastY = y;
        lastAngle = angle;
    }
    return (_jsx(SpinnerContainer, { "$size": size, className: className, children: _jsx("svg", { id: "colourwheel", xmlns: "http://www.w3.org/2000/svg", version: "1.1", width: size, height: size, viewBox: `0 0 ${size * 2} ${size * 2}`, children: _jsx("g", { id: "paths", fill: "none", strokeWidth: "15", transform: `translate(${size}, ${size})`, children: arcs }) }) }));
}
const SpinnerContainer = styled.div `
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	filter: drop-shadow(0 0 ${(props) => props.$size / 8}px rgba(0, 0, 0, 0.2));
	height: 100%;

	#colourwheel {
		animation:
			scale 2s ease-in-out infinite,
			spin 1.4s linear infinite;
	}

	@keyframes scale {
		0% {
			scale: 1;
			opacity: 0.7;
		}
		50% {
			scale: 1.2;
			opacity: 1;
		}
		100% {
			scale: 1;
			opacity: 0.7;
		}
	}

	@keyframes spin {
		100% {
			transform: rotate(360deg);
		}
	}
`;
//# sourceMappingURL=InlineSpinner.js.map